// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__36dtM","navs":"Sidebar_navs__1LBGh","link":"Sidebar_link__obnAo","activeLink":"Sidebar_activeLink__9yZvL"};